import { Injectable, inject } from '@angular/core';
// import { HalApiCaller } from '@dxc-technology/halstack-client';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  private commonService = inject(CommonService);
  private http = inject(HttpClient);

  moduleService: any;
  header: any;
  allMessage: any;
  userId: any;
  persona: any;
  clientNo: any;

  constructor() {
    this.initModuleSerivce();
  }

  async initModuleSerivce() {
    this.moduleService = {};
    this.moduleService.id = '';
    this.moduleService.subsidiariesFlag = false;
    this.moduleService.isFromSubsidiary = false;
    this.header = this.commonService.getHeaders();
    await this.initAllMessage();
  }

  updateUser() {
    this.userId = localStorage.getItem('userName');
    this.persona = sessionStorage.getItem('selected_role');
    this.clientNo = localStorage.getItem('clientNumber');
  }

  getHeaders() {
    this.header = this.commonService.getHeaders();
    if (this.clientNo) {
      return { ...this.header, username: this.userId, persona: this.persona, clientnumber: this.clientNo };
    } else {
      return { ...this.header, username: this.userId, persona: this.persona };
    }
  }

  async initAllMessage() {
    this.updateUser();
    if (!this.allMessage && this.commonService.isHeadersWithPROFILE()) {
      try {
        await this.getAllMessages();
      } catch (error) {}
    }
  }

  async getCountMessages() {
    let linkURL = this.allMessage?._links['message:count'].href;
    // let data = await HalApiCaller.get({
    //   url: linkURL,
    //   headers: this.getHeaders(),
    // });
    // return data;

    return this.http.get(linkURL);
  }

  async getAllMessages() {
    let lang = localStorage.getItem('language');
    // let data = await HalApiCaller.get({
    //   url: environment.API_MESSAGE_SERVER_URL + `?page=0&size=1000&lang=${lang}`,
    //   headers: this.getHeaders(),
    // });
    // this.allMessage = data.body;
    // return data;

    return this.http.get(environment.API_MESSAGE_SERVER_URL + `?page=0&size=1000&lang=${lang}`);
  }

  async getDetailMailById(linkURL: any) {
    // let data = await HalApiCaller.get({
    //   url: linkURL,
    //   headers: this.getHeaders(),
    // });
    // return data;

    return this.http.get(linkURL);
  }

  async getAllTaskOrNoti(linkURL: any, type: any) {
    let lang = localStorage.getItem('language');
    let url = linkURL.slice(0, linkURL.indexOf('?'));
    // let data = await HalApiCaller.get({
    //   url: url + '?type=' + type + `&page=0&size=1000&lang=${lang}`,
    //   headers: this.getHeaders(),
    // });
    // return data;

    return this.http.get(url + '?type=' + type + `&page=0&size=1000&lang=${lang}`);
  }

  async sendUnsuccessfullMessage(userId: any, quoteId: any, quoteNo: any) {
    // let data = await HalApiCaller.post({
    //   headers: this.getHeaders(),
    //   url:
    //     environment.API_MESSAGE_SERVER_URL +
    //     '?type=Task&template=employer_hr_quotation_payment_failed&isSystem=true',
    //   body: {
    //     quoteId,
    //     quoteNo,
    //   },
    // });
    // return data;

    let body = { quoteId, quoteNo };
    return this.http.post(environment.API_MESSAGE_SERVER_URL + '?type=Task&template=employer_hr_quotation_payment_failed&isSystem=true', body);
  }

  async searchMessage(linkURL: any, type: any, valueSearch: any) {
    let lang = localStorage.getItem('language');
    let url = linkURL.slice(0, linkURL.indexOf('?'));
    // let data = await HalApiCaller.get({
    //   url: url + `?type=${type}&searchName=${valueSearch}&lang=${lang}`,
    //   headers: this.getHeaders(),
    // });
    // return data;

    return this.http.get(url + `?type=${type}&searchName=${valueSearch}&lang=${lang}`);
  }

  // Refresh account user for message
  async loginMessage() {
    try {
      // let response = await HalApiCaller.post({
      //   headers: this.getHeaders(),
      //   url: environment.API_MESSAGE_SERVER_URL + '/assignUser'
      // });
      // return response;

      return this.http.post(environment.API_MESSAGE_SERVER_URL + '/assignUser', {});
    } catch (err: any) {
      return err.response.data;
    }
  }

  async getVariableDetailMailById(linkURL: any) {
    // let data = await HalApiCaller.get({
    //   url: linkURL,
    //   headers: this.getHeaders(),
    // });
    // return data;

    return this.http.get(linkURL);
  }
}
